import React from 'react';
import { Container, Typography, Grid, Box, Card, CardContent } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import BackupIcon from '@mui/icons-material/Backup';

const securityFeatures = [
  {
    icon: SecurityIcon,
    title: 'Advanced Protection',
    description: 'State-of-the-art security measures to protect your sensitive data from unauthorized access.'
  },
  {
    icon: LockIcon,
    title: 'Encrypted Storage',
    description: 'Industry-standard encryption protocols to ensure your data remains confidential and secure.'
  },
  {
    icon: ShieldIcon,
    title: 'Secure Recovery',
    description: 'Safe and reliable data recovery processes with strict privacy protocols.'
  },
  {
    icon: BackupIcon,
    title: 'Secure Backup',
    description: 'Regular automated backups with encrypted storage to prevent data loss.'
  }
];

function SecureData() {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 8 }}>
      <Container>
        <Typography 
          variant="h2" 
          align="center" 
          gutterBottom
          className="gradient-text"
          sx={{ mb: 6 }}
        >
          Secure Data
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary" 
          sx={{ mb: 8, maxWidth: 800, mx: 'auto' }}
        >
          Your data security is our top priority
        </Typography>

        <Grid container spacing={4}>
          {securityFeatures.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card 
                className="glass-effect"
                sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.2) 100%)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '15px',
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {React.createElement(feature.icon, { 
                      sx: { 
                        fontSize: 40, 
                        color: 'primary.main',
                        mr: 2 
                      } 
                    })}
                    <Typography variant="h5" component="h3">
                      {feature.title}
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom className="gradient-text">
            Our Security Commitment
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
            We employ industry-leading security practices and advanced encryption technologies to ensure 
            your data remains protected throughout the entire process. Our team of security experts 
            constantly monitors and updates our security protocols to stay ahead of potential threats.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default SecureData;
